import SaveTheDateEtoile from './SaveTheDateEtoile';
import SaveTheDateEditorialRose from './SaveTheDateEditorialRose';
import DigitalInviteMaison from './DigitalInviteMaison';
import DigitalInviteAurea from './DigitalInviteAurea';
import GiftListMerci from './GiftListMerci';
import GiftListAtelier from './GiftListAtelier';
import RsvpEssencia from './RsvpEssencia';
import RsvpClair from './RsvpClair';

export const TEMPLATE_PRESETS = {
  bella_romantic: {
    supportedFormats: ['story', 'post', 'invite', 'whatsapp'],
    layoutType: 'bella_romantic',
    backgroundStyle: { mode: 'photo', gradientAngle: 145, texture: 'veil' },
    imageTreatment: { brightness: 0.98, contrast: 1.02, saturate: 0.9, blur: 0 },
    overlayStyle: { baseOpacity: 0.44, accentOpacity: 0.25, vignette: 0.1 },
    frameStyle: { type: 'line', radius: 30, inset: 18, alpha: 0.32 },
    ornamentStyle: { type: 'minimal' },
    titleStyle: { family: '"Playfair Display", serif', weight: 700, tracking: '0.01em', maxWidth: '95%' },
    metaStyle: { family: 'Inter, sans-serif', weight: 500, tracking: '0.06em', uppercase: false },
    bodyStyle: { family: 'Inter, sans-serif', weight: 500, lineHeight: '1.55' },
    ctaStyle: { mode: 'editorial_label', align: 'left' },
    siteBadgeStyle: { mode: 'ribbon' },
    qrStyle: { mode: 'stamp', surface: 'paper' },
    paletteRules: { lightText: '#FFF9F5', darkText: '#231D1A' },
    contrastStrategy: 'smart-overlay',
    catalogNote: 'Leve, refinado e clássico-contemporâneo'
  },
  jardim_natural: {
    supportedFormats: ['post', 'invite', 'whatsapp'],
    layoutType: 'jardim_natural',
    backgroundStyle: { mode: 'gradient', gradientAngle: 165, texture: 'paper' },
    imageTreatment: { brightness: 1, contrast: 1, saturate: 1, blur: 0 },
    overlayStyle: { baseOpacity: 0.82, accentOpacity: 0.64, vignette: 0.04 },
    frameStyle: { type: 'paper', radius: 22, inset: 30, alpha: 0.24 },
    ornamentStyle: { type: 'botanical' },
    titleStyle: { family: '"Playfair Display", serif', weight: 700, tracking: '0.008em', maxWidth: '90%' },
    metaStyle: { family: 'Inter, sans-serif', weight: 500, tracking: '0.14em', uppercase: true },
    bodyStyle: { family: 'Inter, sans-serif', weight: 500, lineHeight: '1.55' },
    ctaStyle: { mode: 'signature', align: 'center' },
    siteBadgeStyle: { mode: 'inline' },
    qrStyle: { mode: 'chip', surface: 'paper' },
    paletteRules: { lightText: '#FFFDF8', darkText: '#2C221D' },
    contrastStrategy: 'paper-balance',
    catalogNote: 'Natural elegante com atmosfera de papelaria fina'
  },
  lumina_editorial: {
    supportedFormats: ['invite', 'post', 'story', 'whatsapp'],
    layoutType: 'lumina_editorial',
    backgroundStyle: { mode: 'photo', gradientAngle: 142, texture: 'none' },
    imageTreatment: { brightness: 0.86, contrast: 1.12, saturate: 0.88, blur: 0 },
    overlayStyle: { baseOpacity: 0.45, accentOpacity: 0.2, vignette: 0.24 },
    frameStyle: { type: 'edge', radius: 0, inset: 0, alpha: 0 },
    ornamentStyle: { type: 'editorial-lines' },
    titleStyle: { family: '"Playfair Display", serif', weight: 700, tracking: '0.01em', maxWidth: '100%' },
    metaStyle: { family: 'Inter, sans-serif', weight: 500, tracking: '0.1em', uppercase: false },
    bodyStyle: { family: 'Inter, sans-serif', weight: 500, lineHeight: '1.62' },
    ctaStyle: { mode: 'line_label', align: 'left' },
    siteBadgeStyle: { mode: 'editorial_footer' },
    qrStyle: { mode: 'dark-stamp', surface: 'dark' },
    paletteRules: { lightText: '#FFF8F2', darkText: '#201A18' },
    contrastStrategy: 'image-dominant',
    catalogNote: 'Editorial premium com fotografia protagonista'
  },
  petala_poetic: {
    supportedFormats: ['story', 'invite', 'whatsapp', 'post'],
    layoutType: 'petala_poetic',
    backgroundStyle: { mode: 'photo', gradientAngle: 150, texture: 'mist' },
    imageTreatment: { brightness: 0.95, contrast: 1.03, saturate: 1, blur: 0 },
    overlayStyle: { baseOpacity: 0.34, accentOpacity: 0.2, vignette: 0.08 },
    frameStyle: { type: 'soft', radius: 34, inset: 20, alpha: 0.24 },
    ornamentStyle: { type: 'poetic-blur' },
    titleStyle: { family: '"Playfair Display", serif', weight: 700, tracking: '0.01em', maxWidth: '95%' },
    metaStyle: { family: 'Inter, sans-serif', weight: 500, tracking: '0.08em', uppercase: false },
    bodyStyle: { family: 'Inter, sans-serif', weight: 500, lineHeight: '1.58' },
    ctaStyle: { mode: 'soft_tag', align: 'center' },
    siteBadgeStyle: { mode: 'center_label' },
    qrStyle: { mode: 'glass-chip', surface: 'glass' },
    paletteRules: { lightText: '#FFFCFB', darkText: '#2A2221' },
    contrastStrategy: 'local-surface',
    catalogNote: 'Poético etéreo com leitura suave e emocional'
  },
  default: {
    supportedFormats: ['story', 'post', 'invite', 'whatsapp'],
    layoutType: 'bella_romantic',
    backgroundStyle: { mode: 'photo', gradientAngle: 145, texture: 'none' },
    imageTreatment: { brightness: 0.96, contrast: 1.04, saturate: 0.95, blur: 0 },
    overlayStyle: { baseOpacity: 0.48, accentOpacity: 0.28, vignette: 0.12 },
    frameStyle: { type: 'line', radius: 30, inset: 18, alpha: 0.32 },
    ornamentStyle: { type: 'minimal' },
    titleStyle: { family: '"Playfair Display", serif', weight: 700, tracking: '0.01em', maxWidth: '95%' },
    metaStyle: { family: 'Inter, sans-serif', weight: 500, tracking: '0.08em', uppercase: false },
    bodyStyle: { family: 'Inter, sans-serif', weight: 500, lineHeight: '1.55' },
    ctaStyle: { mode: 'editorial_label', align: 'left' },
    siteBadgeStyle: { mode: 'ribbon' },
    qrStyle: { mode: 'stamp', surface: 'paper' },
    paletteRules: { lightText: '#FFF9F5', darkText: '#231D1A' },
    contrastStrategy: 'smart-overlay',
    catalogNote: 'Template premium para convite digital'
  }
};

export const TEMPLATE_LIBRARY = [
  {
    id: 'std-etoile',
    type: 'save_the_date',
    category: 'save_the_date',
    name: 'Étoile',
    subtitle: 'Romântico editorial',
    description: 'Save the date elegante com assinatura clássica e leitura premium.',
    styleLabel: 'Romântico clean',
    recommendedFor: 'Anunciar data com impacto elegante',
    note: 'Leve, refinado e com foco no nome do casal.',
    supportedFormats: ['story', 'post', 'invite', 'whatsapp'],
    format: 'story',
    layout: 'center',
    presetId: 'bella_romantic',
    previewComponent: 'SaveTheDateEtoile',
    baseColor: '#E6B7AF',
    accentColor: '#B89573',
    textColor: '#231D1A',
    isPremium: false,
    premium: false,
    sampleImage: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'std-editorial-rose',
    type: 'save_the_date',
    category: 'save_the_date',
    name: 'Editorial Rose',
    subtitle: 'Fashion wedding',
    description: 'Foto protagonista com painel editorial para stories e convites.',
    styleLabel: 'Editorial moderno',
    recommendedFor: 'Casais com proposta visual sofisticada',
    note: 'Composição de campanha para casamento premium.',
    supportedFormats: ['story', 'invite', 'post'],
    format: 'invite',
    layout: 'split',
    presetId: 'lumina_editorial',
    previewComponent: 'SaveTheDateEditorialRose',
    baseColor: '#81545D',
    accentColor: '#CCAB88',
    textColor: '#FFF8F2',
    isPremium: true,
    premium: true,
    sampleImage: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'inv-maison',
    type: 'digital_invite',
    category: 'digital_invite',
    name: 'Maison',
    subtitle: 'Convite clássico nobre',
    description: 'Convite digital com hierarquia impecável para nome, data e local.',
    styleLabel: 'Papelaria fina',
    recommendedFor: 'Convites formais e elegantes',
    note: 'Visual inspirado em papelaria premium de casamento.',
    supportedFormats: ['invite', 'post', 'whatsapp'],
    format: 'invite',
    layout: 'bottom-card',
    presetId: 'jardim_natural',
    previewComponent: 'DigitalInviteMaison',
    baseColor: '#EADDD2',
    accentColor: '#A8845E',
    textColor: '#1C1C1C',
    isPremium: false,
    premium: false,
    sampleImage: 'https://images.unsplash.com/photo-1465495976277-4387d4b0c88e?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'gradient'
  },
  {
    id: 'inv-aurea',
    type: 'digital_invite',
    category: 'digital_invite',
    name: 'Áurea',
    subtitle: 'Convite editorial premium',
    description: 'Estrutura moderna com presença visual forte e leitura refinada.',
    styleLabel: 'Editorial escuro',
    recommendedFor: 'Casamentos noturnos e visuais dramáticos',
    note: 'Composição premium com painel fotográfico.',
    supportedFormats: ['story', 'invite', 'post', 'whatsapp'],
    format: 'story',
    layout: 'split',
    presetId: 'lumina_editorial',
    previewComponent: 'DigitalInviteAurea',
    baseColor: '#885860',
    accentColor: '#D3AC84',
    textColor: '#FFF8F3',
    isPremium: true,
    premium: true,
    sampleImage: 'https://images.unsplash.com/photo-1513278974582-3e1b4a4fa21e?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'gift-merci',
    type: 'gift_list',
    category: 'gift_list',
    name: 'Merci',
    subtitle: 'Conversão elegante',
    description: 'Arte orientada a cliques com CTA sofisticado para lista.',
    styleLabel: 'Comercial premium',
    recommendedFor: 'Compartilhar lista em WhatsApp e Instagram',
    note: 'Foco em conversão sem perder estética premium.',
    supportedFormats: ['post', 'whatsapp', 'invite'],
    format: 'post',
    layout: 'center',
    presetId: 'bella_romantic',
    previewComponent: 'GiftListMerci',
    baseColor: '#E8B7B1',
    accentColor: '#C8A97E',
    textColor: '#231D1A',
    isPremium: false,
    premium: false,
    sampleImage: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'gift-atelier',
    type: 'gift_list',
    category: 'gift_list',
    name: 'Atelier',
    subtitle: 'Vitrine premium',
    description: 'Composição editorial para apresentar lista, link e QR com destaque.',
    styleLabel: 'Editorial de conversão',
    recommendedFor: 'Campanhas com identidade visual premium',
    note: 'Estrutura com destaque para QR code e ação principal.',
    supportedFormats: ['story', 'post', 'whatsapp'],
    format: 'story',
    layout: 'split',
    presetId: 'lumina_editorial',
    previewComponent: 'GiftListAtelier',
    baseColor: '#DFA8A1',
    accentColor: '#B88C5D',
    textColor: '#FFF9F4',
    isPremium: true,
    premium: true,
    sampleImage: 'https://images.unsplash.com/photo-1544531586-fde5298cdd40?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'rsvp-essencia',
    type: 'rsvp',
    category: 'rsvp',
    name: 'Essência',
    subtitle: 'RSVP poético',
    description: 'Layout limpo com chamada clara para confirmação de presença.',
    styleLabel: 'Poético clean',
    recommendedFor: 'Pedir resposta com elegância',
    note: 'Pouco texto, foco em resposta rápida.',
    supportedFormats: ['story', 'post', 'invite'],
    format: 'story',
    layout: 'frame',
    presetId: 'petala_poetic',
    previewComponent: 'RsvpEssencia',
    baseColor: '#E5BAB4',
    accentColor: '#C8A97E',
    textColor: '#2A1E1A',
    isPremium: false,
    premium: false,
    sampleImage: 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'photo'
  },
  {
    id: 'rsvp-clair',
    type: 'rsvp',
    category: 'rsvp',
    name: 'Clair',
    subtitle: 'Resposta objetiva',
    description: 'Composição direta para confirmar presença em segundos.',
    styleLabel: 'Minimal premium',
    recommendedFor: 'Fluxos rápidos de RSVP',
    note: 'Clareza visual para aumentar confirmações.',
    supportedFormats: ['post', 'whatsapp', 'invite'],
    format: 'post',
    layout: 'bottom-card',
    presetId: 'jardim_natural',
    previewComponent: 'RsvpClair',
    baseColor: '#E8B7B1',
    accentColor: '#C8A97E',
    textColor: '#1C1C1C',
    isPremium: true,
    premium: true,
    sampleImage: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?auto=format&fit=crop&w=1600&q=80',
    backgroundMode: 'gradient'
  }
];

export const TEMPLATE_RENDERERS = {
  'std-etoile': SaveTheDateEtoile,
  'std-editorial-rose': SaveTheDateEditorialRose,
  'inv-maison': DigitalInviteMaison,
  'inv-aurea': DigitalInviteAurea,
  'gift-merci': GiftListMerci,
  'gift-atelier': GiftListAtelier,
  'rsvp-essencia': RsvpEssencia,
  'rsvp-clair': RsvpClair
};
